import axios from "axios";
import { CANCEL_SUBSCRIPTION_URL, DELETE_ACCOUNT_URL } from "../utils";

export const deleteAccount = async () => {
  return await axios.post(DELETE_ACCOUNT_URL);
};
